<template>
  <button @click="handleClick" :class="buttonClass" id="axj-button">
    <img :src="axjButtonFiles.icon">
    <span>
      <slot></slot>
    </span>
  </button>
</template>

<script>

import common from '@/common/common'
export default {
  name: "axj-button-v2",
  props:{
    //按钮类型 [undefined:默认,hollow:空心,hollow-plus:空心、无边框]
    buttonType:{
      type:String,
      default:undefined
    },
    //按钮大小 undefined:默认,normal:普通 medium:中等
    buttonSize:{
      type:String,
      default:undefined
    },
    //按钮图标 edit:编辑 del:删除
    buttonIcon:{
      type:String,
      default:undefined
    },
    //按钮颜色 turquoise:松石绿 red:红色 while:白 bread:黑红
    buttonColor:{
      type:String,
      default:"while"
    }
  },
  data(){
    return{
      axjButtonFiles:{
        icon:common.SystemConfig.PreViewUrl
      },
    }
  },
  watch:{

  },
  methods:{
    handleClick(){
      this.$emit("click")
    },
  },
  computed:{
    buttonClass(v){

      let buttonClass=' axj-button-'+this.buttonColor
      if(this.buttonType){
        buttonClass+=' axj-button-'+this.buttonType
      }
      if(this.buttonIcon){
        this.axjButtonFiles.icon=common.SystemConfig.PreViewUrl+'/axj_web_file/icon/axj-button/'+this.buttonIcon+'.png'
        buttonClass+=' axj-button-container-icon'
      }
      if(this.buttonSize){
        buttonClass+=' axj-button-'+this.buttonSize
      }
      return buttonClass
    }
  }
}
</script>

<style scoped lang="scss">
button[id=axj-button]{
  margin: 0;
  padding: 0;
  border: 1px solid transparent;  //自定义边框
  outline: none;
  font-size: 14.6px;
  color: #ffffff;
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  line-height: 21.186px;
  border-radius: 5px;
  letter-spacing: 0.046em;
  background: none;
  margin-right: 10px;
}
button[class~=axj-button-turquoise][id=axj-button]{
  background-color: #00ADB5;
}
button[class~=axj-button-red][id=axj-button]{
  background-color: red;
}

button[class~=axj-button-bread][id=axj-button]{
  background-color: #E42929;
}
button[class~=axj-button-red][class~=axj-button-hollow][id=axj-button]{
  background-color: #ffffff;
  color: red;
  border-color: red;
}
button[class~='axj-button-turquoise'][class~='axj-button-hollow'][id=axj-button]{
  color: #00ADB5;
  background-color: #ffffff;
  border-color: #00ADB5;

}
button[class~='axj-button-container-icon'][class~='axj-button-medium'][id=axj-button]{
  width: 40px;
  height: 30px;
  img{
    width: 20px;
    height: 20px;
    margin-top: 4px;
  }
}
button[class~='axj-button-container-icon']{
  img{
    width: 20px;
    height: 20px;
  }
}
//button[class~='axj-button-container-icon'][class~='axj-button-red'][class~='axj-button-medium'][id=axj-button]{
//  width: 40px;
//  height: 30px;
//  background-color: #E42929;
//  img{
//    margin-top: 4px;
//  }
//}
//button[class~='axj-button-container-icon'][class~='axj-button-red'][id=axj-button]{
//  img{
//    height: 20px;
//    width: 20px;
//  }
//}
</style>



// WEBPACK FOOTER //
// src/components/common/button/axj-button.vue